import { render, staticRenderFns } from "./frmfeltoltottdokumentumok.vue?vue&type=template&id=7d624029&"
import script from "./frmfeltoltottdokumentumok.vue?vue&type=script&lang=js&"
export * from "./frmfeltoltottdokumentumok.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports